export default __webpack_public_path__ + "static/media/GooglePlayBadgeBlack.adce0c56.svg";